'use strict';

( function ( $ ) {
	// Function to handle copy button click
	function handleCopyButtonClick( event ) {
		const button = event.target.closest(
			'.ld-lesson-section-heading__link-copy'
		);
		if ( button ) {
			const textarea = button.querySelector( 'textarea' );
			if ( textarea ) {
				textarea.select();
				textarea.setSelectionRange( 0, 99999 );
				document.execCommand( 'copy' );
				alert( 'The lesson link is copied!' );
			}
		}
	}

	// Use event delegation for the copy buttons
	document.addEventListener( 'click', function ( event ) {
		if (
			event.target.matches( '.ld-lesson-section-heading__link-copy' ) ||
			event.target.closest( '.ld-lesson-section-heading__link-copy' )
		) {
			handleCopyButtonClick( event );
		}
	} );

	// Reapply event delegation after AJAX content is loaded
	document.addEventListener( 'ajaxComplete', function () {
		// Re-initialize event delegation for new elements
		document.addEventListener( 'click', function ( event ) {
			if (
				event.target.matches(
					'.ld-lesson-section-heading__link-copy'
				) ||
				event.target.closest( '.ld-lesson-section-heading__link-copy' )
			) {
				handleCopyButtonClick( event );
			}
		} );
	} );

	// Function to initialize accordion functionality
	function initializeAccordion() {
		// Use event delegation to handle clicks on dynamically added elements
		$( document ).on(
			'click',
			'.ld-lesson-section-heading__icon-open',
			function () {
				// Get the heading element
				const $heading = $( this ).closest(
					'.ld-item-list-section-heading'
				);

				// Slide toggle items under the current heading
				let $next = $heading.next();

				// Toggle visibility of items until the next heading is encountered
				while (
					$next.length &&
					! $next.hasClass( 'ld-item-list-section-heading' )
				) {
					if ( $next.hasClass( 'ld-item-list-item' ) ) {
						$next.slideToggle();
					}
					$next = $next.next();
				}

				// Remove active class from other headings
				$( '.ld-item-list-section-heading' )
					.not( $heading )
					.removeClass( 'active' )
					.find( '.ld-lesson-section-heading__icon-open' )
					.removeClass( 'active' );

				// Toggle active class for the clicked heading
				$heading.toggleClass( 'active' );
				$( this ).toggleClass( 'active' );
			}
		);
	}

	// Initialize accordion functionality

	initializeAccordion();
} )( jQuery );
